import {
    EuiButton,
    EuiFlexGroup,
    EuiFlexItem,
    EuiPage,
    EuiPageSection,
    EuiPanel,
    EuiSpacer,
    EuiSwitch,
    EuiText,
    EuiTitle,
} from "@elastic/eui";
import client from "api/Client";
import React, { useContext, useState } from "react";
import { ShopContext } from "utils/Shop";

import AddShopGroupModal from "./AddShopGroupModal";
import PermissionsUsersList from "./PermissionsUsersList";
import ShopGroupList from "./ShopGroupList";

export const AdminPage = () => {
    const [showModal, setShowModal] = useState(false);

    const { shopId, isUsingMultiScreen, setIsUsingMultiScreen, config, setConfig } = useContext(ShopContext);

    function updateMultiscreen(value: boolean) {
        setIsUsingMultiScreen(value);
        client.put(`/v1/shops/set-multiscreen/${shopId}?multiscreen=${value}`);
    }

    function updateTruncatedPrices(value: boolean) {
        setConfig({
            use_truncated_prices: value,
        });
        client.put(`/v1/shops/set-config/${shopId}`, {
            use_truncated_prices: value,
        });
    }

    return (
        <EuiPage>
            <EuiPageSection>
                <EuiFlexGroup direction="column">
                    <EuiFlexItem grow={false}>
                        <EuiTitle>
                            <EuiText>Pricelist options:</EuiText>
                        </EuiTitle>
                    </EuiFlexItem>
                    <EuiFlexItem grow={false}>
                        <EuiSwitch
                            onChange={(e) => updateMultiscreen(e.target.checked)}
                            checked={isUsingMultiScreen}
                            label="Enable Multiscreen for current shop?"
                        />
                    </EuiFlexItem>
                    <EuiFlexItem grow={false}>
                        <EuiSwitch
                            onChange={(e) => updateTruncatedPrices(e.target.checked)}
                            checked={config.use_truncated_prices}
                            label="Use truncated prices on pricelist for current shop?"
                        />
                    </EuiFlexItem>
                </EuiFlexGroup>
                <EuiSpacer />
                <EuiFlexGroup alignItems="center">
                    <EuiFlexItem grow={false}>
                        <EuiTitle>
                            <EuiText>Edit Shop Groups</EuiText>
                        </EuiTitle>
                    </EuiFlexItem>
                    <EuiFlexItem grow={false}>
                        <EuiButton onClick={() => setShowModal(true)} iconType="plus">
                            Add Shop Group
                        </EuiButton>
                    </EuiFlexItem>
                </EuiFlexGroup>
                <EuiSpacer size="m" />
                <EuiPanel>
                    <ShopGroupList />
                </EuiPanel>
                <EuiSpacer />
                <EuiFlexGroup alignItems="center">
                    <EuiFlexItem grow={false}>
                        <EuiTitle>
                            <EuiText>Assign users to shop groups</EuiText>
                        </EuiTitle>
                    </EuiFlexItem>
                </EuiFlexGroup>
                <EuiSpacer size="m" />
                <EuiPanel>
                    <PermissionsUsersList />
                </EuiPanel>
            </EuiPageSection>
            <AddShopGroupModal showModal={showModal} setShowModal={setShowModal} />
        </EuiPage>
    );
};
